export default "__VITE_ASSET__c001379c__"